// suitsData.ts
import { LiveTv, Groups, School, ShoppingCart } from "@mui/icons-material";
import { ReactElement } from "react";

export interface SuitCard {
  title: string;
  desc: string;
  gradient: string;
  icon: ReactElement;
}
export const suits: SuitCard[] = [
  {
    title: "Clover – Live Events",
    desc: "Broadcast large-scale virtual events like concerts, fan meets, talk shows, and interactive performances. Users can purchase tickets to join in real time, with options for live reactions, stage camera switching, and backstage access.",
    gradient: "linear-gradient(135deg,#00b09b,#96c93d)",
    icon: <LiveTv sx={{ fontSize: 40, color: "#fff" }} />,
  },
  {
    title: "Heart – Community",
    desc: "Host intimate group sessions such as AMAs, charity streams, fan interactions, or supporter circles. Perfect for creators, changemakers, or niche communities to foster belonging through meaningful, real-time connection.",
    gradient: "linear-gradient(135deg,#ff416c,#ff4b2b)",
    icon: <Groups sx={{ fontSize: 40, color: "#fff" }} />,
  },
  {
    title: "Spade – Learning",
    desc: "Offer knowledge-driven 1-on-1 or group experiences such as tutoring, mentorship, bootcamps, or masterclasses. Ideal for experts, educators, coaches, or consultants delivering real-time, skill-based learning.",
    gradient: "linear-gradient(135deg,#1e3c72,#2a5298)",
    icon: <School sx={{ fontSize: 40, color: "#fff" }} />,
  },
  {
    title: "Diamond – Commerce",
    desc: "Run live shopping experiences including product drops, exclusive demos, or QVC-style selling sessions. Engage users with instant checkout, showcase products in action, and drive sales through authentic live interaction.",
    gradient: "linear-gradient(135deg,#7f00ff,#e100ff)",
    icon: <ShoppingCart sx={{ fontSize: 40, color: "#fff" }} />,
  },
];

